var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.publication)?_c('Markdown',{staticClass:"mt-4",attrs:{"subtitle":_vm.publication.title,"content":_vm.publication.md}}):_c('S404')
}
var staticRenderFns = []

export { render, staticRenderFns }